<template>
  <div>
    <div v-if="!isAuthorized">
      <div class="form-horizontal px-2">
          <div class="row" style="text-align: center">
            <div class="col-12">
              <p>{{ $helper.trans('Enter_phone_number_message') }}</p>
            </div>
            <div class="m-auto" style="margin: 0 auto; max-width: max-content;">
              <div class="form-group">
                <input v-model="phoneNumber" class="input-big" :placeholder="$helper.trans('Phone_number_placeholder')">
              </div>
              <div v-if="authorizationError" class="error-message">{{ authorizationError }}</div>
              <button type="button" class="btn btn-yellow" style="margin-top: 5px;" @click="authorizeForControls">Peržiūrėti</button>
            </div>
          </div>
      </div>
    </div>
    <div v-else-if="isAlreadyChanged" class="text-center font-weight-bold h3 pt-5">
      {{ $helper.trans('Parcel_data_already_changed_message') }}
    </div>
    <div v-else-if="wasChangedSuccessfully" class="text-center font-weight-bold h3 pt-5">
      {{ $helper.trans('Parcel_data_changed_successfully_message') }}
    </div>
    <div v-else>
      <div>
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $helper.trans('Shipment_number') }}:</th>
              <td>{{parcel.bcd_lbl}}</td>
            </tr>
            <tr v-show="activeEditingBlock === null">
              <th>{{ $helper.trans('Receiver') }}:</th>
              <td>{{parcel.imp_nme_imptr}}</td>
            </tr>
            <tr v-show="activeEditingBlock === null">
              <th>{{ $helper.trans('Delivery_address') }}:</th>
              <td>{{parcel.imp_nme_imptr_street}}, {{parcel.imp_nme_imptr_city}},
                LT-{{parcel.imp_nme_imptr_pst_code}}</td>
            </tr>
            <tr v-show="activeEditingBlock === null">
              <th>{{ $helper.trans('Contact_person')}}:</th>
              <td>{{parcel.imp_nme_imptr_cntct}}</td>
            </tr>
            <tr>
              <th>{{ $helper.trans('Check_delivery_date') }}:</th>
              <td>
                <a :href="`http://wwwapps.ups.com/etracking/tracking.cgi?tracknums_displayed=1&TypeOfInquiryNumber=T&InquiryNumber1=${parcel.bcd_lbl}&track=Track`"
                   target="_blank" class="text-decoration-none">{{ $helper.trans('Click_on_url') }}</a></td>
            </tr>
          </table>
        </div>

          <div class="col-12 btn-block text-center d-flex flex-column flex-lg-row justify-content-center flex-wrap ga-4">
            <input type="button" class="btn btn-yellow mx-auto mx-lg-0 col-12 col-md-8 col-lg-2" :value="$helper.trans('Change_delivery_address')" @click="toggleEditingBlock('change_address')">
            <input type="button" class="btn btn-yellow mx-auto mx-lg-0 col-12 col-md-8 col-lg-2" :value="$helper.trans('Pickup_at_the_terminal')" @click="toggleEditingBlock('change_terminal')">
            <input type="button" class="btn btn-yellow mx-auto mx-lg-0 col-12 col-md-8 col-lg-2" :value="$helper.trans('Leave_in_a_safe_place')" @click="toggleEditingBlock('safe_place_button')">
            <input type="button" class="btn btn-danger text-white mx-auto mx-lg-0 col-12 col-md-8 col-lg-2" :value="$helper.trans('Stop_sending_sms')" @click="confirmStopSendingMessages">
          </div>

          <div class="editing-blocks">
            <ParcelControlChangeAddress
                v-if="activeEditingBlock === 'change_address'"
                :holidays="holidays"
                :errors="errors"
                @save="handleSave"
            />
            <ParcelControlChangeTerminal
                v-else-if="activeEditingBlock === 'change_terminal'"
                :holidays="holidays"
                :cities-url="routes['api.parcel_control.get_cities']"
                :terminals-url="routes['api.parcel_control.get_terminals']"
                :work-time-url="routes['api.parcel_control.get_work_time']"
                :errors="errors"
                @save="handleSave"
            />
            <ParcelControlSafePlace
                v-else-if="activeEditingBlock === 'safe_place_button'"
                :errors="errors"
                @save="handleSave"
            />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParcelControlChangeAddress from "./ParcelControlChangeAddress.vue";
import ParcelControlChangeTerminal from "./ParcelControlChangeTerminal.vue";
import ParcelControlSafePlace from "./ParcelControlSafePlace.vue";

export default {
  components: {
    ParcelControlSafePlace,
    ParcelControlChangeTerminal, ParcelControlChangeAddress},
  data: function () {
    return {
      routes: {},
      isAuthorized: false,
      isAlreadyChanged: false,
      wasChangedSuccessfully: false,
      phoneNumber: '',
      parcel: null,
      activeEditingBlock: null,
      safePlaceForm: {
        remarks: '',
      },
      holidays: [],
      offices: [],
      terminals: [],
      cities: [],
      errors: {},
      authorizationError: ''
    }
  },
  props: {
    trackingNumber: {
      type: String,
      require: true,
    },
    routesJson: {
      type: String,
      required: true,
    },
  },
  created: function () {
    this.routes = JSON.parse(Base64.decode(this.routesJson));
  },
  mounted: function () {
    this.fetchHolidays()
    this.fetchParcelData()
  },
  methods: {
    authorizeForControls() {
      this.authorizationError = ''
      let url = this.routes['api.parcel_control.authorization']
      url = url.replace(':TRACKING_NUMBER', this.trackingNumber)

      axios.post(url, {
          phone_number: this.phoneNumber
        }).then((response) => {
            if (response.data.changed === true) {
              this.isAlreadyChanged = true
            } else {
              this.fetchParcelData()
            }
            this.isAuthorized = true
      }).catch(() => {
        this.authorizationError = this.$helper.trans('Authorization_failed_message')
      })
    },
    fetchParcelData() {
      let url = this.routes['api.parcel_control.data']
      url = url.replace(':TRACKING_NUMBER', this.trackingNumber)
      axios.get(url, {
        phone_number: this.phoneNumber
      }).then((response) => {
        if (response.data.changed === true) {
          this.isAlreadyChanged = true
        } else {
          this.parcel = response.data.parcel
        }
        this.isAuthorized = true
      }).catch((e) => {
        console.error(e)
      })
    },
    fetchHolidays() {
      axios.get(this.routes['api.parcel_control.get_holidays']).then((res) => {
        this.holidays = res.data
      }).catch((e) => {
        console.error(e)
      });
    },
    toggleEditingBlock(block) {
      this.errors = {}
      if (this.activeEditingBlock === block) {
        this.activeEditingBlock = null
      } else {
        this.activeEditingBlock = block
      }
    },
    confirmStopSendingMessages() {
      if (!confirm(this.$helper.trans('Confirm_stop_sending_sms'))) {
        return
      }

      const data = {
        stop_send: 999,
        opened_box: 0
      }

      this.handleSave(data)
    },
    handleSave(data) {
      this.errors = {}
      let url = this.routes['api.parcel_control.update']
      url = url.replace(':TRACKING_NUMBER', this.trackingNumber)
      let body = {
        sun_nr: this.parcel.bcd_lbl,
        id: this.parcel.id,
        ...data
      }
      axios.post(url, body)
          .then(() => {
            this.wasChangedSuccessfully = true
          })
          .catch((e) => {
        this.errors = e.response.data.errors
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table th {
  text-align: end;
}
.table > tr > * {
  width: 50%;
}

.editing-blocks {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  width: 100%;
}

::v-deep .input-big {
  border-radius: .25rem;
  display: block;
  width: 100%;
  padding: .5rem 1rem;
}

::v-deep textarea {
  width: 100%;
  padding: .5rem 1rem;
}

::v-deep {
  .col-form-label {
    font-weight: 700;
    font-size: .875rem;
  }

  .error-message {
    color: #dc3545;
    font-size: .675rem;
  }
}

::v-deep .select2-container {
  display: block !important;
  width: 100%;

  .select2-selection {
    border-radius: .25rem !important;
    height: 38px;

    .select2-selection__rendered {
      line-height: 38px;
    }
  }
}

.btn-block {
  gap: .5rem;

  .btn {
    min-width: fit-content;
  }
}
</style>
